var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.method)?_c('Button',{attrs:{"background":_vm.background,"color":_vm.color},nativeOn:{"click":function($event){return _vm.click.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.title))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }